import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { useTranslation } from 'next-i18next';
import styles from '@features/categories/components/CategoriesMobileBottomPanel/CategoriesMobileBottomPanel.styles';
import { ICategoriesMobileBottomPanelProps } from '@features/categories/typescript';
import CategoriesFilterPanel from '@features/categories/components/CategoriesFilterPanel/CategoriesFilterPanel';
import { useResponsive } from '@features/responsive';
const CategoriesMobileBottomPanel = ({
  productsCount,
  filterToggle,
  onFilterButtonClick,
  listingRef
}: ICategoriesMobileBottomPanelProps) => {
  const {
    isMobile
  } = useResponsive();
  const [mobile, setMobile] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const {
    t
  } = useTranslation('filters');
  useEffect(() => {
    setMobile(!!isMobile);
    const checkIfWithinListing = () => {
      const listingElement = listingRef.current;
      if (!listingElement) {
        return false;
      }
      const listingRect = listingElement.getBoundingClientRect();
      let viewportHeight = window.innerHeight;
      if (window.visualViewport && window.visualViewport.height > 0) {
        viewportHeight = window.visualViewport.height;
      }
      const tolerance = 50;
      const listingFillsViewport = listingRect.top <= tolerance && listingRect.bottom >= viewportHeight - tolerance;
      return listingFillsViewport;
    };
    const handleScroll = () => {
      const isWithinListing = checkIfWithinListing();
      setIsVisible(isWithinListing);
    };
    const debouncedHandleScroll = debounce(handleScroll, 100);
    if (isMobile) {
      window.addEventListener('scroll', debouncedHandleScroll);
      // Dodatkowy event listener dla iPhone 17 Pro Max
      window.addEventListener('resize', debouncedHandleScroll);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', debouncedHandleScroll);
        window.visualViewport.addEventListener('scroll', debouncedHandleScroll);
      }
      handleScroll();
    }
    return () => {
      window.removeEventListener('scroll', debouncedHandleScroll);
      window.removeEventListener('resize', debouncedHandleScroll);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', debouncedHandleScroll);
        window.visualViewport.removeEventListener('scroll', debouncedHandleScroll);
      }
      debouncedHandleScroll.cancel();
    };
  }, [isMobile, listingRef]);
  const handleSortClick = () => {
    filterToggle();
    onFilterButtonClick('sort');
  };
  return <div sx={styles.mobileBottomPanel(mobile, isVisible)}>
      <CategoriesFilterPanel position="horizontal" productsCount={productsCount} leftButtonText={t('filterChoice')} rightButtonText={t('sortChoice')} handleLeftButtonClick={filterToggle} handleRightButtonClick={handleSortClick} />
    </div>;
};
export default CategoriesMobileBottomPanel;